(function () {
  if (window.__yySplitReady) return;
  window.__yySplitReady = true;

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () { fallbackCopy(text); });
    }
    fallbackCopy(text);
    return Promise.resolve();
  }

  // One delegated listener, works even if the theme re-renders the product section
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.yy-split__offer');
    if (!btn) return;

    var code = btn.getAttribute('data-code');
    if (!code) return;

    copyText(code).then(function () {
      btn.classList.add('is-copied');
      setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
    });
  });
})();
/* =====================================================================
   COUPON SAVING from Flow metaobject (window.YY_DISCOUNTS)
   ===================================================================== */
function yySplit(s) {
  return (s || '').toLowerCase().split('|').map(function (x) { return x.trim(); }).filter(Boolean);
}

function yyMainQty() {
  var q = parseInt((document.querySelector('.quantity__input') || {}).value, 10);
  return isNaN(q) || q < 1 ? 1 : q;
}

function yyMainUnitCents() {
  var form = document.querySelector('form[data-type="add-to-cart-form"]') ||
             document.querySelector('form.js-product-form[action*="/cart/add"]');
  var idInput = form && form.querySelector('[name="id"]');
  var json = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
  if (idInput && json) {
    try {
      var v = JSON.parse(json.textContent).filter(function (x) { return String(x.id) === String(idInput.value); })[0];
      if (v) return Number(v.price);
    } catch (e) {}
  }
  var base = document.getElementById('bold-price-update');
  return base ? Number(base.getAttribute('data-inc-base-price')) || 0 : 0;
}

// every line that will be in the cart
function yyCollectLines() {
  var wrap = document.querySelector('[data-yy-split]');
  if (!wrap) return [];
  var qty = yyMainQty();
  var lines = [{
    productId: Number(wrap.dataset.mainId) || 0,
    collections: yySplit(wrap.dataset.mainCollections),
    unit: yyMainUnitCents(),
    qty: qty
  }];

  var parentId = Number((document.querySelector('input[name="product-id"]') || {}).value || 0);
  var seen = {};

  function addCard(card, isDeliveryCard) {
    var d = card.dataset;
    if (!d.variantId || seen[d.variantId]) return;
    seen[d.variantId] = true;
    var aq = qty;
    if (typeof pdpGetAccessoryQuantity === 'function') {
      var del = isDeliveryCard ||
        (typeof pdpIsDeliveryName === 'function' && pdpIsDeliveryName(d.variantName));
      aq = pdpGetAccessoryQuantity(parentId, qty, d.variantId, del);
    }
    lines.push({
      productId: Number(d.productId) || 0,
      collections: yySplit(d.collections),
      unit: Number(d.variantPrice) || 0,
      qty: aq
    });
  }
  document.querySelectorAll('.accessory-card.active').forEach(function (c) { addCard(c, false); });
  document.querySelectorAll('.delivery-card.selected').forEach(function (c) { addCard(c, true); });
  return lines;
}

function yyEligible(rule, line) {
  if (rule.applies === 'all_items') return true;
  if (rule.applies === 'specific_products') return rule.products.indexOf(line.productId) > -1;
  if (rule.applies === 'specific_collections') {
    return line.collections.some(function (h) { return rule.collections.indexOf(h) > -1; });
  }
  return false;
}

// returns saving in pounds
function yySavingFor(code, lines) {
  var rule = (window.YY_DISCOUNTS || {})[String(code).toUpperCase()];
  if (!rule || rule.status !== 'ACTIVE') return null;   // missing or inactive

  var eligible = lines.filter(function (l) { return yyEligible(rule, l); });
  var subtotal = eligible.reduce(function (s, l) { return s + l.unit * l.qty; }, 0);
  if (!eligible.length) return 0;
  if (rule.min && subtotal / 100 < rule.min) return 0;   // minimum not met

  var cents = 0;
  eligible.forEach(function (l) {
    if (rule.type === 'fixed_amount') {
      cents += Math.min(rule.amount * 100, l.unit) * l.qty;
    } else {
      cents += Math.ceil(l.unit * l.qty * rule.amount / 100 - 0.5); // half rounds down like Shopify
    }
  });
  return cents / 100;
}

function updateCouponSaving() {
  var wrap = document.querySelector('[data-yy-split]');
  var offers = document.querySelectorAll('.yy-split__offer');
  if (!wrap || !offers.length) return;

  var sym = wrap.dataset.symbol || '';
  var lines = yyCollectLines();

  var src = document.querySelector('.rrp-wrapper.rrp_price') ||
            document.querySelector('.price.inc-vat.totalprice.money');
  var staticBase = src ? parseFloat(src.textContent.replace(/[^0-9.]/g, '')) : NaN;

  offers.forEach(function (offer) {
    var title = offer.querySelector('.yy-split__title');
    if (!title) return;
    var old = title.querySelector('.yy-js-saving');
    if (old) old.remove();

    var code = offer.dataset.code;
    var text = null;

       if (code === 'FREEINSTALL') {
      text = ' Save ' + sym + '119.95';
    } else if (offer.classList.contains('yy-split__offer--static') || !code) {
      var pct = parseFloat(offer.dataset.percent);
      if (!isNaN(pct) && !isNaN(staticBase)) text = ' Save ' + sym + (staticBase * pct / 100).toFixed(2);
    } else {
      if (offer.dataset.noSaving) return;
      var s = yySavingFor(code, lines);
      if (s !== null && s > 0) text = ' Save ' + sym + s.toFixed(2);
    }

    if (text) {
      var span = document.createElement('span');
      span.className = 'yy-js-saving';
      span.textContent = text;
      title.appendChild(span);
    }
  });
}
window.yyUpdateCouponSaving = updateCouponSaving;

var yyTimer;
function yySchedule(d) { clearTimeout(yyTimer); yyTimer = setTimeout(updateCouponSaving, d || 150); }

document.addEventListener('DOMContentLoaded', function () {
  updateCouponSaving();
  setTimeout(updateCouponSaving, 800);
  setTimeout(updateCouponSaving, 1800);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.accessory-add-btn, .modal-select, .bc-cmp-add, .color-circle, .delivery-card, .quantity__button')) yySchedule(200);
  });
  document.addEventListener('change', function () { yySchedule(250); });
  new MutationObserver(function (m) {
    var ext = m.some(function (x) {
      var n = x.target.nodeType === 1 ? x.target : x.target.parentElement;
      return !(n && n.closest('.yy-split'));
    });
    if (ext) yySchedule(150);
  }).observe(document.body, { childList: true, subtree: true });
});
document.addEventListener('shopify:section:load', function () { yySchedule(100); });